export default __webpack_public_path__ + "static/grass-2000-d6bdef3eac3683a21e6b7f83e149c9a4.jpg";